// DebateInfo.jsx
import React, { useState, useEffect } from 'react';
import styles from './DebateInfo.module.css';
import Button from '../../ui/Button';
import {useLocation } from "react-router-dom";

const DebateInfo = ({ state, activeTurn, arena, canStartDebate, debateStatus, onStartDebate }) => {
  const [expanded, setExpanded] = useState(false);
  const [status, setstatus] = useState('archived');
  const location = useLocation();

  const sched = new Date(`${arena.schedule.date}T${arena.schedule.time}`);
  const turnStartTime = activeTurn?.turnStartTime ? new Date(activeTurn.turnStartTime) : null;
  const turnCount = state?.turnIndex !== undefined && debateStatus === 'active' ? state.turnIndex + 1 : 0;
  const totaldebateSec = (state?.turns || []).reduce((acc, turn) => acc + (turn?.durationSec || 0), 0);

  const teamsInTurns = Array.from(new Set((state?.turns || []).map(t => t.team).filter(Boolean)));
  const totalRemainingSec = Math.round(teamsInTurns.reduce((acc, team) => acc + (Number(state?.teamTimeRemaining?.[team]) || 0), 0));
  const totalRemainingSecInt = Math.max(0, Math.floor(totalRemainingSec));

  const min = String(Math.floor(totalRemainingSecInt / 60)).padStart(2, '0');
  const sec = String(totalRemainingSecInt % 60).padStart(2, '0');

  // Tag logic simplified
  const now = new Date();
  // Ready window (how long after the scheduled time the debate can still be started)
  // - Use arena.custom.readywindow (hours) if provided, otherwise default to 24h.
  const readyWindowHours = Number(arena.custom?.readywindow) || 24;
  const readyWindowMs = readyWindowHours * 60 * 60 * 1000;

  function getDebateStatus() {
    if (debateStatus === 'active') return 'live';
    if (sched > now) return 'scheduled';

    const sinceSched = now.getTime() - sched.getTime();
    if (sinceSched <= readyWindowMs && debateStatus !== 'ended') return 'ready';
    return 'archived';
  }

  useEffect(() => {
    var stats = getDebateStatus();
    setstatus(stats);
  }, [arena, debateStatus]);

 // console.log('DebateInfo render:', { status, canStartDebate, debateStatus } );

  return (
    <div className={styles.debateInfo}>
      <h1 className={styles.title}>{arena.title}</h1>
      {/*<p className={styles.topic}>{arena.topic.text}</p>*/}
		<div className={styles.topic}>
		  <p className={styles.topicText}>
			{expanded || !(arena.topic.text && arena.topic.text.length > 100)
			  ? arena.topic.text : `${arena.topic.text?.slice(0, 100)}... `}
		  </p>
		  {arena.topic.text && arena.topic.text.length > 100 && (
			<Button
			  variant="secondary"
			  className={styles.seeMoreBtn}
			  onClick={(e) => {
				e.stopPropagation(); // prevent card click
				setExpanded((!expanded));
			  }}
			>
			  {expanded ? 'See less' : 'See more'}
			</Button>
		  )}
		</div>
      <div className={styles.stats}>
        <span>Round {state?.currentRound} / {state?.totalRounds}</span>
        <span>Turn {turnCount}</span>
        <span className={styles.timer}>{min}:{sec}</span>
      </div>
      <div className={styles.tags}>
        {status === 'ready' && canStartDebate && debateStatus === 'idle' ? (
          <Button variant="secondary" onClick={onStartDebate}>
            Start Debate
          </Button>
        ) : (
              <span className={styles[status]}>{status.toUpperCase()}</span>
            )}
      </div>
    </div>
  );
};

export default DebateInfo;
